// Declare action names as constants with uppercase string

import ApiService from '../services/ApiService';
export const ACCESS_COMPONENT_BEGIN = 'ACCESS_COMPONENT_BEGIN';
export const ACCESS_COMPONENT_SUCCESS = 'ACCESS_COMPONENT_SUCCESS';
export const ACCESS_COMPONENT_FAILURE = 'ACCESS_COMPONENT_FAILURE';
export const ACCESS_COMPONENT_CLEAR = 'ACCESS_COMPONENT_CLEAR';

// Thunk: this is a special type of action that can dispatch other actions
export function fetchAccessComponent(data) {
    return async dispatch => {
        dispatch(accessComponentBegin());
        await ApiService.setAccessComponent(data)
            .then(
                result => {
                    dispatch(accessComponentSuccess(result));
                },
                error => {
                    dispatch(accessComponentFailure(error));
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'Ops! user authentication failed' });
                }
            )
    };
}

// Action: Function that returns an object with action data for reducer
export const accessComponentBegin = () => ({
    type: ACCESS_COMPONENT_BEGIN
});
export const accessComponentSuccess = data => ({
    type: ACCESS_COMPONENT_SUCCESS,
    payload: { data }
});
export const accessComponentFailure = error => ({
    type: ACCESS_COMPONENT_FAILURE,
    payload: { error }
});
export const accessComponentClear = () => ({
    type: ACCESS_COMPONENT_CLEAR,
});